import { render, staticRenderFns } from "./Candle.vue?vue&type=template&id=30f23aa0&scoped=true&"
import script from "./Candle.vue?vue&type=script&lang=js&"
export * from "./Candle.vue?vue&type=script&lang=js&"
import style0 from "./Candle.vue?vue&type=style&index=0&id=30f23aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f23aa0",
  null
  
)

export default component.exports